
export function currencyToSymbol(currencyCode) {
    switch (currencyCode) {
      case "826":
        return "£"; // British Pound
      case "978":
        return "€"; // Euro
      default:
        return ""; // Default empty symbol for other currencies
    }
  };